// Offers Container Component
// Container that renders all offer cards

import { OFFERS } from "./offers-config.ts";
import type { OfferCard } from "./offer-card.ts";

class OffersContainer extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  private setupAddonsListener() {
    const addonsBox = this.querySelector("offer-addons-box");
    if (addonsBox) {
      addonsBox.addEventListener("addons-change", ((e: CustomEvent) => {
        const total = e.detail.total;
        // Update both diagnosis and prognosis cards
        const diagnosisCard = this.querySelector('offer-card[offer-id="diagnosis"]') as OfferCard;
        const prognosisCard = this.querySelector('offer-card[offer-id="prognosis"]') as OfferCard;

        if (diagnosisCard) {
          diagnosisCard.updateAddonsTotal(total);
        }
        if (prognosisCard) {
          prognosisCard.updateAddonsTotal(total);
        }
      }) as EventListener);
    }
  }

  private render() {
    // Create offer cards for each offer in the config
    const cardsHtml = OFFERS.map((offer) => {
      return `<offer-card offer-id="${offer.id}" class="flex"></offer-card>`;
    }).join("\n");

    // Add the add-ons box as a separate card
    const addonsBoxHtml = `
      <div class="flex">
        <div class="bg-white rounded-2xl shadow-lg border-2 border-slate-200 overflow-hidden flex flex-col h-full w-full">
          <div class="bg-gradient-to-br from-yellow-400 to-orange-500 p-8">
            <h3 class="text-2xl font-bold mb-2 text-slate-800">
              <span data-en="Add-ons" data-lv="Papildinājumi" data-it="Componenti aggiuntivi">Add-ons</span>
            </h3>
            <p class="text-slate-700 text-sm mb-6">
              <span data-en="Enhance your analysis" data-lv="Uzlabojiet savu analīzi" data-it="Migliora la tua analisi">Enhance your analysis</span>
            </p>
          </div>
          <div class="p-8 flex flex-col flex-grow">
            <p class="text-sm text-slate-600 mb-4">
              <span data-en="Select additional focus areas to include in your Diagnosis and Prognosis packages." data-lv="Izvēlieties papildu fokusa jomas, ko iekļaut Diagnozes un Prognozes paketēs." data-it="Seleziona aree di focus aggiuntive da includere nei pacchetti Diagnosi e Prognosi.">
                Select additional focus areas to include in your Diagnosis and Prognosis packages.
              </span>
            </p>
            <offer-addons-box></offer-addons-box>
          </div>
        </div>
      </div>
    `;

    this.innerHTML = cardsHtml + addonsBoxHtml;

    // Set config for each card after rendering
    setTimeout(() => {
      const cards = this.querySelectorAll("offer-card");
      cards.forEach((card, index) => {
        (card as OfferCard).setConfig(OFFERS[index]);
      });

      // Setup add-ons listener
      this.setupAddonsListener();

      // Re-apply language after all cards are rendered
      if (globalThis.switchLang) {
        const currentLang = localStorage.getItem("dammi_lang") || "en";
        globalThis.switchLang(currentLang);
      }
    }, 0);
  }
}

customElements.define("offers-container", OffersContainer);

export { OffersContainer };

